module.exports={
    "两次输入的密码必须一致": "Пароль, введенный дважды, должен быть одинаковым",
    "取消": "Отменить",
    "如验证出现问题，请点击": "Если с проверкой возникла проблема, нажмите",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Если есть проблема с проверкой, пожалуйста, свяжитесь с нами.upcs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Если есть проблема с проверкой, пожалуйста, свяжитесь с нами.upcs@asiainnovations.com",
    "密码修改成功": "Пароль был успешно изменен.",
    "密码格式错误": "Неверный формат пароля",
    "密码由6-20位由数字和字母组成": "Пароль состоит из 6-20 цифр или букв",
    "恭喜您密码重置成功": "Успешно сброшен пароль",
    "恭喜您已成功激活帐户": "Поздравляем с успешной активацией вашего аккаунта",
    "知道了": "Ясно",
    "确认修改": "Подтвердить изменение",
    "网络连接有误, 请稍后再试": "Проблема с сетью. Повторите попытку позже.",
    "联系客服": "Поддержка клиентов",
    "请再次输入密码": "Введите пароль еще раз.",
    "请返回UpVoice中重新进行邮箱验证": "Пожалуйста, вернитесь к UpVoice, чтобы проверить почтовый ящик.",
    "请返回Up直播中重新进行邮箱验证": "Пожалуйста, вернитесь к Uplive, чтобы проверить почтовый ящик.",
    "请返回虎鲸直播中重新进行邮箱验证": "Пожалуйста, вернитесь к Orcalive, чтобы проверить почтовый ящик.",
    "请重新设定登录密码": "Сбросьте пароль для входа в систему",
    "请重新设置密码": "Сбросьте пароль",
    "赶快返回UpVoice中与全球潮人互动吧": "Вернитесь в UpVoice, чтобы веселиться с друзьями в мире !",
    "赶快返回Up直播中与全球潮人互动吧！": "Вернитесь в Up Live, чтобы веселиться с друзьями в мире !",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Вернитесь в Orcalive, чтобы веселиться с друзьями в мире !",
    "重置密码失败": "Не удалось сбросить пароль",
    "验证失败": "Ошибка проверки",
    "验证成功": "Успешно проверено"
};


// WEBPACK FOOTER //
// ./js/lang/ruru.js